import { FontProperties } from "components/stories/video-studio/utils/getOrganizationDefaultFonts";

const getLanguageDefaultFonts = (language: string, organization?: string): FontProperties | {} => {
  let fontFamily = "";
  let fontWeigh = "";
  switch (language) {
    case "ja":
      fontFamily = "Dela Gothic One";
      fontWeigh = "700";
      if (organization && organization === "Microsoft") {
        fontFamily = "Yu Gothic UI Semibold";
        fontWeigh = "600";
      }
      return {
        font_family: fontFamily,
        font_weight: fontWeigh
      };
    case "zh-CN":
      fontFamily = "Noto Sans SC";
      fontWeigh = "700";
      if (organization && organization === "Microsoft") {
        fontFamily = "Microsoft Yahei";
        fontWeigh = "400";
      }
      return {
        font_family: fontFamily,
        font_weight: fontWeigh
      };
    case "zh-TW":
      fontFamily = "Noto Sans SC";
      fontWeigh = "700";
      if (organization && organization === "Microsoft") {
        fontFamily = "Microsoft JhengHei";
        fontWeigh = "400";
      }
      return {
        font_family: fontFamily,
        font_weight: fontWeigh
      };
    case "ar":
    case "ar-SA":
      return {
        font_family: "Amiri",
        font_weight: "700"
      };
    case "he":
      return {
        font_family: "Alef",
        font_weight: "700"
      };
    case "ko":
      return {
        font_family: "Noto Sans KR",
        font_weight: "700"
      };
    case "hi":
      return {
        font_family: "Amiko",
        font_weight: "700"
      };
    case "th":
      return {
        font_family: "Athiti",
        font_weight: "700"
      };
    case "gu":
      return {
        font_family: "Baloo Bhai 2",
        font_weight: "700"
      };
    case "si":
      return {
        font_family: "Abhaya Libre",
        font_weight: "700"
      };
    case "el":
      return {
        font_family: "Advent Pro",
        font_weight: "700"
      };
    case "kn":
      return {
        font_family: "Akaya Kanadaka",
        font_weight: "400"
      };
    case "te":
      return {
        font_family: "Akaya Telivigala",
        font_weight: "400"
      };
    case "ta":
    case "ml":
      return {
        font_family: "Arima Madurai",
        font_weight: "700"
      };
    case "bn":
      return {
        font_family: "Atma",
        font_weight: "700"
      };
    default:
      return {};
  }
};

export default getLanguageDefaultFonts;
